import React from 'react';
import { Box, Typography } from '@mui/material';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';

interface Props {
    onSuggest?: (question: string) => void;
}

const EmptyState: React.FC<Props> = ({ onSuggest }) => (
    <Box
        sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            px: 2,
            py: 3,
            gap: 1,
        }}
    >
        {/* Icon */}
        <Box
            sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: '#EEEDFE',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 0.5,
            }}
        >
            <AutoFixHighOutlinedIcon sx={{ fontSize: 22, color: '#534AB7' }} />
        </Box>

        {/* Heading */}
        <Typography sx={{ fontSize: 14, fontWeight: 500, color: 'text.primary' }}>
            Ask about your collection
        </Typography>

        {/* Subtext */}
        <Typography
            sx={{
                fontSize: 12,
                color: 'text.secondary',
                lineHeight: 1.6,
                maxWidth: 220,
            }}
        >
            Query your artworks, valuations, loans, and portfolio in plain English.
        </Typography>
    </Box>
);

export default EmptyState;